import React from "react";
import PersonIcon from "@mui/icons-material/Person";
import { CastMember } from "../../../../utils/types";
import "./index.css";

interface MovieCastProps {
  cast: CastMember[];
}

export default function MovieCast({ cast }: MovieCastProps) {
  if (!cast || cast.length === 0) return null;

  return (
    <div className="cast-container">
      <h3 className="section-title">Cast</h3>
      <div className="cast-scroll-container">
        {cast.slice(0, 15).map((member) => (
          <div key={member.id} className="cast-member-card">
            {member.profile_path ? (
              <img
                src={`${process.env.REACT_APP_RAPID_IMAGE_BASE_URL}/w185/${member.profile_path}`}
                alt={member.name}
                className="cast-member-photo"
                loading="lazy"
              />
            ) : (
              <div className="cast-member-placeholder">
                <PersonIcon sx={{ fontSize: 40 }} />
              </div>
            )}
            <div className="cast-member-info">
              <p className="cast-member-name" title={member.name}>
                {member.name}
              </p>
              <p className="cast-member-character" title={member.character}>
                {member.character}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
